/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Firstname_Placeholder1Inputs */

const en_firstname_placeholder1 = /** @type {(inputs: Firstname_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Max`)
};

const de_firstname_placeholder1 = /** @type {(inputs: Firstname_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Max`)
};

/**
* | output |
* | --- |
* | "e.g. Max" |
*
* @param {Firstname_Placeholder1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const firstname_placeholder1 = /** @type {((inputs?: Firstname_Placeholder1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Firstname_Placeholder1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_firstname_placeholder1(inputs)
	return en_firstname_placeholder1(inputs)
});
export { firstname_placeholder1 as "firstName_placeholder" }